import type { WidgetDefinition } from '../WidgetDefinition';
import { faMessageExclamation } from '@fortawesome/pro-regular-svg-icons/faMessageExclamation';
import type { MessagesWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import { parseInstrument } from 'src/lib/instrumentUtils';
import type { MessagesWidgetViewModel } from 'src/store/types';

class MessagesWidgetDefinition implements WidgetDefinition<MessagesWidgetViewModel, MessagesWidgetModel> {
    type = 'messages' as const;
    nameKey = 'widgets::messages::name' as const;
    roles = ['widgets::messages'];
    icon = faMessageExclamation;
    category = 'widgets::categories::trading' as const;

    /**
     * Converts a Messages widget from contract model to view model
     */
    toViewModel(widget: MessagesWidgetModel): MessagesWidgetViewModel {
        return {
            ...widget,
            instrument: parseInstrument(''),
            type: 'messages',
        };
    }

    /**
     * Converts a Messages widget from view model to contract model
     */
    toContractModel(widget: MessagesWidgetViewModel): MessagesWidgetModel {
        const { instrument: _instrument, ...contractWidget } = widget;
        return contractWidget;
    }
}

export const messagesWidgetDefinition = new MessagesWidgetDefinition();
